<div class="payment-simulator-admin card bg-am-darkblue-x border-am p-3 mb-3" *ngIf="shouldShow">
  <!-- Header -->
  <div class="card-header bg-transparent border-0 p-0 mb-2">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="text-white fs-24px fw-medium-x mb-0">
        <i class="fas fa-credit-card me-2"></i>
        {{ 'payment_simulator.admin.title' | translate }}
      </h4>
      <div class="d-flex align-items-center gap-2">
        <span 
          class="badge fs-16px px-3 py-1"
          [class.bg-success]="isEnabled"
          [class.bg-danger]="!isEnabled">
          <i class="fas" [class.fa-check-circle]="isEnabled" [class.fa-times-circle]="!isEnabled"></i>
          {{ (isEnabled ? 'payment_simulator.admin.status_enabled' : 'payment_simulator.admin.status_disabled') | translate }}
        </span>
        <button 
          type="button"
          class="btn btn-primary py-1 px-3"
          style="font-size: 14px;"
          (click)="openTransactionsModal(transactionsModal)">
          <i class="fas fa-eye me-2"></i>
          {{ 'payment_simulator.admin.show_transactions' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Info Message -->
  <div class="alert alert-info bg-blue-cart border-0 text-white mb-0 p-2">
    <i class="fas fa-info-circle me-2"></i>
    <span style="font-size: 14px;">{{ 'payment_simulator.admin.auto_control_message' | translate }}</span>
  </div>

</div>

<!-- Modal de Transacciones -->
<ng-template #transactionsModal let-modal>
  <div class="modal-header bg-am-darkblue-x border-0">
    <h4 class="modal-title text-white fs-28px fw-medium-x">
      <i class="fas fa-chart-line me-2"></i>
      Detalle de Transacciones
    </h4>
    <button type="button" class="am-modal-close" aria-label="Close" (click)="modal.dismiss()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="modal-body bg-am-darkblue-x p-4">
    <!-- Statistics -->
    <div class="statistics-section mb-4" *ngIf="statistics && transactions.length > 0">
      <h5 class="text-white fs-22px fw-medium mb-3">
        <i class="fas fa-chart-bar me-2"></i>
        {{ 'payment_simulator.admin.statistics' | translate }}
      </h5>
      
      <div class="row g-3">
        <!-- Total -->
        <div class="col-md-4">
          <div class="stat-card bg-blue-cart p-3 rounded text-center">
            <div class="text-white opacity-75 fs-14px mb-1">{{ 'payment_simulator.admin.total_simulations' | translate }}</div>
            <div class="text-white fs-32px fw-bold">{{ statistics.total }}</div>
          </div>
        </div>

        <!-- Successful -->
        <div class="col-md-4">
          <div class="stat-card bg-success p-3 rounded text-center">
            <div class="text-white opacity-75 fs-14px mb-1">{{ 'payment_simulator.admin.successful' | translate }}</div>
            <div class="text-white fs-32px fw-bold">{{ statistics.successful }}</div>
          </div>
        </div>

        <!-- Failed -->
        <div class="col-md-4">
          <div class="stat-card bg-danger p-3 rounded text-center">
            <div class="text-white opacity-75 fs-14px mb-1">{{ 'payment_simulator.admin.failed' | translate }}</div>
            <div class="text-white fs-32px fw-bold">{{ statistics.failed }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Transactions Table -->
    <div class="transactions-section mt-4">
      <h5 class="text-white fs-22px fw-medium mb-3">
        <i class="fas fa-list me-2"></i>
        {{ 'payment_simulator.admin.transactions_history' | translate }}
        <span class="badge bg-secondary ms-2">{{ transactions.length }}</span>
      </h5>

      <div class="table-container-wrapper mb-3" *ngIf="transactions.length > 0">
        <table class="table table-dark table-striped table-hover">
          <thead>
            <tr>
              <th>{{ 'payment_simulator.admin.table.date' | translate }}</th>
              <th>{{ 'payment_simulator.admin.table.brand' | translate }}</th>
              <th>{{ 'payment_simulator.admin.table.card' | translate }}</th>
              <th>{{ 'payment_simulator.admin.table.amount' | translate }}</th>
              <th>{{ 'payment_simulator.admin.table.scenario' | translate }}</th>
              <th>{{ 'payment_simulator.admin.table.status' | translate }}</th>
              <th>{{ 'payment_simulator.admin.table.auth_code' | translate }}</th>
              <th class="text-center">{{ 'payment_simulator.admin.table.actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tx of transactions">
              <td>{{ tx.date | date:'short' }}</td>
              <td>
                <i class="fab fa-{{getBrandIcon(tx.brand)}} me-2"></i>
                {{ tx.brand }}
              </td>
              <td class="font-monospace">{{ tx.cardNumber }}</td>
              <td class="fw-bold">${{ tx.amount | number:'1.2-2' }}</td>
              <td>
                <span class="badge" [ngClass]="getScenarioClass(tx.scenario)">
                  {{ 'payment_simulator.scenarios.' + tx.scenario | translate }}
                </span>
              </td>
              <td>
                <span class="badge" [class.bg-success]="tx.success" [class.bg-danger]="!tx.success">
                  <i class="fas" [class.fa-check]="tx.success" [class.fa-times]="!tx.success"></i>
                  {{ (tx.success ? 'payment_simulator.admin.success' : 'payment_simulator.admin.error') | translate }}
                </span>
              </td>
              <td class="font-monospace">{{ tx.authCode || 'N/A' }}</td>
              <td class="text-center">
                <button 
                  type="button"
                  class="btn btn-sm btn-danger"
                  (click)="deleteTransaction(tx.id)"
                  [title]="'payment_simulator.admin.delete' | translate">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="alert alert-info text-white" *ngIf="transactions.length === 0">
        <i class="fas fa-info-circle me-2"></i>
        {{ 'payment_simulator.admin.no_transactions' | translate }}
      </div>
    </div>
  </div>

  <div class="modal-footer bg-am-darkblue-x border-0">
    <div class="d-flex gap-2">
      <!-- Limpiar Historial -->
      <button 
        type="button" 
        class="btn btn-warning"
        [disabled]="transactions.length === 0"
        (click)="clearTransactions()">
        <i class="fas fa-trash me-2"></i>
        {{ 'payment_simulator.admin.clear' | translate }}
      </button>
      
      <!-- Exportar JSON -->
      <button 
        type="button" 
        class="btn btn-info"
        [disabled]="transactions.length === 0"
        (click)="exportTransactions()">
        <i class="fas fa-download me-2"></i>
        {{ 'payment_simulator.admin.export' | translate }}
      </button>
    </div>
  </div>
</ng-template>


